<template>
</template>
<script>

	export default {
		name: 'DayControl',
		computed: {
			time: {
				get() { return this.$store.state.time },
				set(value) { this.$store.commit('set_time', value)}
			},
			day: {
				get() { return this.$store.state.day },
				set(value) { this.$store.commit('set_day', value)}
			},
			log() {
				return this.$store.state.log
			},
			start_time() { return this.$config.start_time},
			end_time() { return this.$config.end_time},
			workers() { return this.$store.state.workers }
		},
		watch: {
			time: {
				handler() {
					let eod = true;
					let min_workers = false;
					for (let i in this.workers) {
						let worker = this.workers[i];
						if (worker.status == -1 || worker.status == 'injury') continue;


						if (worker.end == false) eod = false;
						min_workers = true;
					}
					if (!min_workers) {
						eod = false;
						let end_time = this.moment().hour(this.$config.end_time.hour).minute(this.$config.end_time.minute).second(0).format("H:mm");
						let current_time = this.moment().hour(this.start_time.hour).minute(this.start_time.minute).second(this.time).format("H:mm");
						if (this.moment(current_time, 'H:mm').isSameOrAfter(this.moment(end_time, 'H:mm'))) {
							eod = true;
						}



					}


					if (eod) {



						let event_id = this.$finder.next_id(this.log);
						let event = {type: 'eod', time: this.time, id: event_id, day: this.day};
						this.$set(this.log, event_id, event);

						for (let i in this.workers) {
							let worker = this.workers[i];
							worker.end = false;
							worker.mode = null;
						}

						this.day = this.day + 1;
						this.time = 0;
					}
				}

			}
		}
	}
</script>
